export default __webpack_public_path__ + "../staticImages/flamenco-260.png";